import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 5em 0;
    background-color: #F3F3F3;

    .layout-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .public-layout-description {
        width: 43%;
    }

    @media all and (max-width: ${variables.mobileM}) {
        .public-layout-description {
            width: 100%;
        }

        .animation {
            display: none;
        }
    }

`;